/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Embed_Links_HintInputs */



/**
* | output |
* | --- |
* | "Allows links that members share to show embedded content in text channels." |
*
* @param {Leveling_Perm_Embed_Links_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_embed_links_hint = /** @type {((inputs?: Leveling_Perm_Embed_Links_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Embed_Links_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет показывать встроенный контент у ссылок, которые участники публикуют в текстовых каналах.")
	return /** @type {LocalizedString} */ ("Allows links that members share to show embedded content in text channels.")
});